// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint no-irregular-whitespace: 'off' */
//import  { createApp } from 'vue';

import mitt from 'mitt';

//Vue3 import { createWebHistory, createWebHashHistory, createRouter } from "vue-router";
//import VueRouter from 'vue-router'
//import { createStore } from 'vuex';
import Vue from 'vue';
import App from './App.vue'
import router from '@/router'
import Vuex from 'vuex';
import store from './store'
//import 'es6-promise';
import 'es6-promise/auto'; //for IE11 when use Axios and esri-loader
import 'es6-object-assign/auto'; //for IE11 when use vue-js-modal
import { sync } from 'vuex-router-sync';
import "core-js/stable";
import "regenerator-runtime/runtime";

//https://stackoverflow.com/questions/52813291/how-to-load-a-font-file-in-vuejs-and-webpack
// eslint-disable-next-line


//must call Vue.use(Vuex) before creating a store instance.
const emitter = mitt();
//Vue3 const app = createApp(App, {
//Vue3 });
    // render: (h) => h(App)
//Vue3 app.provide('emitter', emitter);  

//app.config.globalProperties.emitter = emitter;

// const router = createRouter({
//     // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
//     history: createWebHashHistory(),
//     routes, // short for `routes: routes`
//   });

// const router = new Router({
//     routes
// });

//Vue3 app.use(router);
//Vue3 app.use(store);

//Vue.config.productionTip = false
/* eslint-disable no-new */
// Register a global custom directive called `v-focus`
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.focus()
    }
});
Vue.directive('focus-if', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, vm) {
        // Focus the element
        if (vm.value)
            el.focus();
    }
});



//console.log(dataStore);
Vue.use(Vuex);
//const store = new Vuex.Store({ state: dataStore });
//console.log(store);
//var store = storeIndex.createStore();
//const current = new Vuex.Store({
//  state: {
//    count: 0
//  },
//  mutations: {
//    increment: state => state.count++,
//    decrement: state => state.count--
//  }
//})

//const store = new Vuex.Store({
//    modules
//});

const app = new Vue({
    router,
    store,
    render: h => h(App)
});


//Vue.use(store);





store.dispatch('display/setEmitter', emitter);
app.$mount('#app');

